export default "/assets/images/cooking-video-thumbnail.100e35759d9fc482.jpg";